import { Link } from "react-router-dom";
import { Instagram, Youtube } from "lucide-react";
import { SITE } from "../data/site";
import { TikTokIcon } from "./icons/TikTokIcon";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-black">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src={SITE.logo} alt="USDD" className="h-12 w-12 object-contain" />
            <div>
              <div className="font-display font-black uppercase text-white text-lg leading-none">USDD Academy</div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mt-1">Upside Down Dance · Est. Kent</div>
            </div>
          </div>
          <p className="text-sm text-zinc-400 max-w-md leading-relaxed">
            Urban dance, theatre &amp; creative performance training — from first class to BA pathway.
          </p>
          <div className="mt-5 pt-5 border-t border-white/10 max-w-md">
            <p className="text-xs text-zinc-400 leading-relaxed">
              Part of the{" "}
              <a
                href="https://usddnetworks.co.uk"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-usdd-networks-link"
                className="text-brand-yellow font-bold hover:underline"
              >
                USDD Networks
              </a>{" "}
              ecosystem.
            </p>
            <a
              href="#ecosystem"
              data-testid="footer-soul-collective-link"
              className="mt-2 inline-block text-[11px] uppercase tracking-[0.25em] text-zinc-500 hover:text-brand-purpleLight transition-colors"
            >
              Soul Collective CIC — Community & Social Impact →
            </a>
          </div>
        </div>

        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-brand-yellow font-bold mb-4">Explore</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li><Link to="/training" data-testid="footer-link-training" className="hover:text-brand-yellow transition-colors">Weekly Training</Link></li>
            <li><Link to="/adult-registration" data-testid="footer-link-adult-registration" className="hover:text-brand-yellow transition-colors">Adult Registration</Link></li>
            <li><Link to="/kids" data-testid="footer-link-kids" className="hover:text-brand-yellow transition-colors">USDD Kids</Link></li>
            <li><Link to="/kids-registration" data-testid="footer-link-kids-registration" className="hover:text-brand-yellow transition-colors">Kids Registration</Link></li>
            <li><Link to="/kids-referral" data-testid="footer-link-kids-referral" className="hover:text-brand-yellow transition-colors">Parent Referral</Link></li>
            <li><Link to="/private-coaching" data-testid="footer-link-private-coaching" className="hover:text-brand-yellow transition-colors">Private 1-to-1 Coaching</Link></li>
            <li><Link to="/youth-theatre" data-testid="footer-link-youth-theatre" className="hover:text-brand-yellow transition-colors">Youth Theatre Company</Link></li>
            <li><Link to="/ba-pathway" data-testid="footer-link-ba-pathway" className="hover:text-brand-yellow transition-colors">BA Pathway</Link></li>
            <li><Link to="/workshops" data-testid="footer-link-workshops" className="hover:text-brand-yellow transition-colors">Workshops</Link></li>
            <li><Link to="/schools-organisations" data-testid="footer-link-schools" className="hover:text-brand-yellow transition-colors">Schools &amp; Organisations</Link></li>
            <li><Link to="/online" data-testid="footer-link-online" className="hover:text-brand-yellow transition-colors">Online Courses</Link></li>
            <li><Link to="/events" data-testid="footer-link-events" className="hover:text-brand-yellow transition-colors">Events</Link></li>
            <li><Link to="/schedule" data-testid="footer-link-schedule" className="hover:text-brand-yellow transition-colors">Find a Class</Link></li>
            <li><Link to="/pricing" data-testid="footer-link-pricing" className="hover:text-brand-yellow transition-colors">Pricing</Link></li>
            <li><Link to="/blog" data-testid="footer-link-blog" className="hover:text-brand-yellow transition-colors">Blog</Link></li>
            <li><Link to="/merch" data-testid="footer-link-merch" className="hover:text-brand-yellow transition-colors">Merch</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-brand-yellow transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-brand-yellow font-bold mb-4">Social</div>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li><a href={SITE.socials.youtube.url} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-yellow transition-colors"><Youtube size={14} /> {SITE.socials.youtube.handle}</a></li>
            <li><a href={SITE.socials.instagram_main.url} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-yellow transition-colors"><Instagram size={14} /> {SITE.socials.instagram_main.handle}</a></li>
            <li><a href={SITE.socials.instagram_kids.url} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-yellow transition-colors"><Instagram size={14} /> {SITE.socials.instagram_kids.handle}</a></li>
            <li><a href={SITE.socials.instagram_media.url} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-yellow transition-colors"><Instagram size={14} /> {SITE.socials.instagram_media.handle}</a></li>
            <li><a href={SITE.socials.tiktok_networks.url} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-yellow transition-colors"><TikTokIcon size={13} /> TikTok {SITE.socials.tiktok_networks.handle}</a></li>
            <li><a href={SITE.socials.tiktok_kids.url} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-yellow transition-colors"><TikTokIcon size={13} /> TikTok {SITE.socials.tiktok_kids.handle}</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-zinc-500">
          <div className="text-center sm:text-left">
            © {new Date().getFullYear()} Up Side Down Dance Academy (USDD Academy). All rights reserved.
            <span className="block text-[10px] uppercase tracking-[0.22em] text-zinc-600 mt-1">
              Operated by{" "}
              <a
                href="https://usddnetworks.co.uk"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-operated-by-link"
                className="text-zinc-500 hover:text-brand-yellow transition-colors underline-offset-2 hover:underline"
              >
                USDD Networks
              </a>
            </span>
          </div>
          <div className="flex items-center gap-5 uppercase tracking-[0.25em] flex-wrap justify-center">
            <Link to="/privacy-policy" data-testid="footer-link-privacy" className="hover:text-brand-yellow transition-colors">Privacy</Link>
            <Link to="/terms" data-testid="footer-link-terms" className="hover:text-brand-yellow transition-colors">Terms</Link>
            <Link to="/policies" data-testid="footer-link-policies" className="hover:text-brand-yellow transition-colors">Policies &amp; Safeguarding</Link>
            <span className="hidden sm:inline">Movement · Culture · Career</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
